import { createInstance } from "i18next";

// Dedicated kiosk namespace; does not replace the application's shared locales.
const en = {
  bookingSlots: "Choose an available time",
  bookingReference: "Booking reference",
  bookAppointment: "Book Appointment",
  bookHint: "Reserve a visit for today or another day",
  visitDate: "Appointment date",
  appointmentBooked: "Appointment booked",
  bookingReceipt:
    "Your appointment is reserved. Check in when you arrive at the hospital.",
  progress: "Check-in progress",
  navigation: "Check-in navigation",
  progressPatient: "Patient",
  progressAppointment: "Appointment",
  progressDoctor: "Doctor",
  progressTime: "Time",
  anotherDoctor: "Choose another doctor",
  askReception: "Reception can help you arrange your visit.",
  allDoctors: "All Doctors",
  allDepartments: "All Departments",
  searchDoctors: "Search doctors by name",
  searchDepartments: "Search departments",
  filterDepartment: "Filter by department",
  clearDepartment: "Clear filter",
  doctorResults: "{{count}} doctors",
  departmentResults: "{{count}} departments",
  doctorVisit: "Consultation",
  viewTimes: "View available times",
  viewDoctors: "View doctors",
  noMatches: "No matches found. Try another name or department.",
  welcome: "Welcome to MA care",
  subtitle: "How can we help you today?",
  checkin: "Check In",
  checkinHint: "I already have an appointment",
  walkin: "Walk In",
  walkinHint: "I am a registered patient without an appointment",
  new: "New Patient",
  newHint: "This is my first visit",
  language: "Language",
  back: "Back",
  home: "Start over",
  phoneTitle: "Enter your contact number",
  phoneHint:
    "Use the number registered with the hospital. Reception will confirm your identity.",
  phone: "Contact number",
  next: "Continue",
  loading: "Please wait…",
  appointments: "Choose today's appointment",
  patients: "Who is visiting today?",
  doctors: "Choose a doctor",
  slots: "Choose an available time today",
  noResults: "No options available. Please speak to reception.",
  name: "Patient full name",
  dob: "Date of birth",
  gender: "Gender",
  male: "Male",
  female: "Female",
  non_binary: "Non-binary",
  transgender: "Transgender",
  details: "Enter patient details",
  detailsHint: "We will create a patient record and register today's visit.",
  confirm: "Confirm your visit",
  confirmCheckin: "Check in now",
  confirmWalkin: "Register and check in",
  received: "You're checked in",
  receipt: "Arrival receipt",
  reception:
    "Please show this receipt at reception. Staff will help with your file, payment and next station.",
  done: "Done · next patient",
  reset: "This screen clears automatically after 30 seconds.",
  urgent: "Need urgent medical help? Please speak to staff immediately.",
  error:
    "We couldn't complete that step. Please try again or speak to reception.",
  unavailable: "Self check-in is unavailable. Please speak to reception.",
  privacy:
    "Your information is used to register your visit. This screen clears after two minutes of inactivity.",
  previous: "Previous",
  more: "More",
  selectedDoctor: "Doctor",
  selectedPatient: "Patient",
  selectedTime: "Time",
  changeNumber: "Change number",
  booked: "Booked",
  arrived: "Arrived",
  checked_in: "Checked in",
  appointmentOnly: "Only today's appointments at this facility are shown.",
  selectGender: "Select gender",
  search: "Search doctors",
  logo: "MA care logo",
};
const ml: Record<keyof typeof en, string> = {
  bookingSlots: "ലഭ്യമായ സമയം തിരഞ്ഞെടുക്കുക",
  bookingReference: "ബുക്കിംഗ് റഫറൻസ്",
  bookAppointment: "അപ്പോയിന്റ്മെന്റ് ബുക്ക് ചെയ്യുക",
  bookHint: "ഇന്നോ മറ്റൊരു ദിവസമോ സന്ദർശനം ബുക്ക് ചെയ്യുക",
  visitDate: "അപ്പോയിന്റ്മെന്റ് തീയതി",
  appointmentBooked: "അപ്പോയിന്റ്മെന്റ് ബുക്ക് ചെയ്തു",
  bookingReceipt: "ആശുപത്രിയിൽ എത്തുമ്പോൾ ചെക്ക് ഇൻ ചെയ്യുക.",
  progress: "ചെക്ക്-ഇൻ ഘട്ടങ്ങൾ",
  navigation: "ചെക്ക്-ഇൻ നാവിഗേഷൻ",
  progressPatient: "രോഗി",
  progressAppointment: "അപ്പോയിന്റ്മെന്റ്",
  progressDoctor: "ഡോക്ടർ",
  progressTime: "സമയം",
  anotherDoctor: "മറ്റൊരു ഡോക്ടറെ തിരഞ്ഞെടുക്കുക",
  askReception: "സന്ദർശനം ക്രമീകരിക്കാൻ റിസപ്ഷനിൽ സഹായം ലഭിക്കും.",
  allDoctors: "എല്ലാ ഡോക്ടർമാരും",
  allDepartments: "എല്ലാ വിഭാഗങ്ങളും",
  searchDoctors: "ഡോക്ടറുടെ പേര് തിരയുക",
  searchDepartments: "വിഭാഗങ്ങൾ തിരയുക",
  filterDepartment: "വിഭാഗം തിരഞ്ഞെടുക്കുക",
  clearDepartment: "ഫിൽട്ടർ നീക്കുക",
  doctorResults: "{{count}} ഡോക്ടർമാർ",
  departmentResults: "{{count}} വിഭാഗങ്ങൾ",
  doctorVisit: "കൺസൾട്ടേഷൻ",
  viewTimes: "ലഭ്യമായ സമയം കാണുക",
  viewDoctors: "ഡോക്ടർമാരെ കാണുക",
  noMatches: "വിവരങ്ങൾ കണ്ടെത്തിയില്ല. മറ്റൊരു പേരോ വിഭാഗമോ തിരയുക.",
  welcome: "MA care-ലേക്ക് സ്വാഗതം",
  subtitle: "ഇന്ന് ഞങ്ങൾ എങ്ങനെ സഹായിക്കണം?",
  checkin: "ചെക്ക് ഇൻ",
  checkinHint: "എനിക്ക് അപ്പോയിന്റ്മെന്റ് ഉണ്ട്",
  walkin: "നേരിട്ടുള്ള സന്ദർശനം",
  walkinHint: "ഞാൻ രജിസ്റ്റർ ചെയ്ത രോഗിയാണ്; അപ്പോയിന്റ്മെന്റ് ഇല്ല",
  new: "പുതിയ രോഗി",
  newHint: "ഇത് എന്റെ ആദ്യ സന്ദർശനമാണ്",
  language: "ഭാഷ",
  back: "തിരികെ",
  home: "വീണ്ടും തുടങ്ങുക",
  phoneTitle: "ഫോൺ നമ്പർ നൽകുക",
  phoneHint:
    "ആശുപത്രിയിൽ രജിസ്റ്റർ ചെയ്ത നമ്പർ നൽകുക. റിസപ്ഷനിൽ നിങ്ങളുടെ തിരിച്ചറിയൽ സ്ഥിരീകരിക്കും.",
  phone: "ഫോൺ നമ്പർ",
  next: "തുടരുക",
  loading: "ദയവായി കാത്തിരിക്കുക…",
  appointments: "ഇന്നത്തെ അപ്പോയിന്റ്മെന്റ് തിരഞ്ഞെടുക്കുക",
  patients: "ഇന്ന് ആരാണ് സന്ദർശിക്കുന്നത്?",
  doctors: "ഡോക്ടറെ തിരഞ്ഞെടുക്കുക",
  slots: "ഇന്ന് ലഭ്യമായ സമയം തിരഞ്ഞെടുക്കുക",
  noResults: "ലഭ്യമായ വിവരങ്ങളില്ല. ദയവായി റിസപ്ഷനുമായി ബന്ധപ്പെടുക.",
  name: "രോഗിയുടെ മുഴുവൻ പേര്",
  dob: "ജനനത്തീയതി",
  gender: "ലിംഗം",
  male: "പുരുഷൻ",
  female: "സ്ത്രീ",
  non_binary: "നോൺ-ബൈനറി",
  transgender: "ട്രാൻസ്ജെൻഡർ",
  details: "രോഗിയുടെ വിവരങ്ങൾ നൽകുക",
  detailsHint: "രോഗിയുടെ രേഖയും ഇന്നത്തെ സന്ദർശനവും രജിസ്റ്റർ ചെയ്യും.",
  confirm: "സന്ദർശനം സ്ഥിരീകരിക്കുക",
  confirmCheckin: "ചെക്ക് ഇൻ ചെയ്യുക",
  confirmWalkin: "രജിസ്റ്റർ ചെയ്ത് ചെക്ക് ഇൻ ചെയ്യുക",
  received: "ചെക്ക് ഇൻ പൂർത്തിയായി",
  receipt: "എത്തിച്ചേരൽ രസീത്",
  reception:
    "ഈ രസീത് റിസപ്ഷനിൽ കാണിക്കുക. ഫയൽ, പണമടയ്ക്കൽ, അടുത്ത ഘട്ടം എന്നിവയിൽ ജീവനക്കാർ സഹായിക്കും.",
  done: "പൂർത്തിയായി · അടുത്ത രോഗി",
  reset: "30 സെക്കൻഡിന് ശേഷം ഈ സ്ക്രീൻ സ്വയം മായും.",
  urgent: "അടിയന്തര ചികിത്സ ആവശ്യമാണോ? ഉടൻ ജീവനക്കാരെ സമീപിക്കുക.",
  error:
    "ഈ ഘട്ടം പൂർത്തിയാക്കാനായില്ല. വീണ്ടും ശ്രമിക്കുക അല്ലെങ്കിൽ റിസപ്ഷനെ സമീപിക്കുക.",
  unavailable: "സ്വയം ചെക്ക് ഇൻ ഇപ്പോൾ ലഭ്യമല്ല. റിസപ്ഷനെ സമീപിക്കുക.",
  privacy:
    "സന്ദർശനം രജിസ്റ്റർ ചെയ്യാനാണ് വിവരങ്ങൾ ഉപയോഗിക്കുന്നത്. രണ്ട് മിനിറ്റ് ഉപയോഗിക്കാതിരുന്നാൽ സ്ക്രീൻ മായും.",
  previous: "മുമ്പത്തെ",
  more: "കൂടുതൽ",
  selectedDoctor: "ഡോക്ടർ",
  selectedPatient: "രോഗി",
  selectedTime: "സമയം",
  changeNumber: "നമ്പർ മാറ്റുക",
  booked: "ബുക്ക് ചെയ്തു",
  arrived: "എത്തിച്ചേർന്നു",
  checked_in: "ചെക്ക് ഇൻ ചെയ്തു",
  appointmentOnly:
    "ഈ സ്ഥാപനത്തിലെ ഇന്നത്തെ അപ്പോയിന്റ്മെന്റുകൾ മാത്രം കാണിക്കുന്നു.",
  selectGender: "ലിംഗം തിരഞ്ഞെടുക്കുക",
  search: "ഡോക്ടറെ തിരയുക",
  logo: "MA care ലോഗോ",
};
const i18n = createInstance();
void i18n.init({
  lng: "en",
  fallbackLng: "en",
  defaultNS: "kiosk",
  initAsync: false,
  resources: { en: { kiosk: en }, ml: { kiosk: ml } },
  interpolation: { escapeValue: false },
});
export default i18n;
